var map = {
	"./Arrow_circle_up_solid.svg": "504d",
	"./Overlay.svg": "a98d7",
	"./TN_marker_map-Design.svg": "9646",
	"./active.svg": "b3e7",
	"./add-circle-w.svg": "ced0",
	"./add-circle.svg": "8729",
	"./add-p.svg": "3b0b",
	"./add-s.svg": "001c",
	"./address-at.svg": "ae57",
	"./address.svg": "e8fc",
	"./analyse-svgrepo-com.svg": "f7c5",
	"./analytics-graph.svg": "ee55",
	"./analytics.svg": "f412",
	"./angle-down.svg": "fa03",
	"./angle-up.svg": "dca6",
	"./ar.svg": "3257",
	"./arrow-circle-up-p.svg": "1b0e",
	"./arrow-left-2-w.svg": "582a",
	"./arrow-left-black.svg": "1d62",
	"./arrow-left.svg": "ac3b",
	"./arrow-right-2-w.svg": "27bd",
	"./bag-w.svg": "3c5f",
	"./bag.svg": "47fd",
	"./bassic-badge.png": "566a",
	"./bassic-badge.svg": "39e3",
	"./bell-alt-ring-p.svg": "181d",
	"./bell-alt-ring.svg": "f11a",
	"./bill.svg": "5ac8",
	"./brand-adversal.svg": "5597",
	"./bread.svg": "3124",
	"./calander-w.svg": "e845",
	"./calendar-add.svg": "f193",
	"./calendar-w.svg": "a223",
	"./campaign.svg": "8872",
	"./capsules.svg": "940f",
	"./car-3-svgrepo-com.svg": "f0e6",
	"./cart-large-p.svg": "6e05",
	"./check-circle-s.svg": "a28e",
	"./check-circle-white.svg": "ba4a",
	"./check-circle.svg": "cfcb",
	"./check-double.svg": "4a52",
	"./check.svg": "7bae",
	"./checked.gif": "9c82",
	"./clean-table.svg": "5934",
	"./clock-circle-svgrepo-com.svg": "f405",
	"./close-danger.svg": "ed6f",
	"./close-dark.svg": "2c95",
	"./close.svg": "8b1b",
	"./cloud-upload.svg": "ecad",
	"./cogwheel-svgrepo-com.svg": "69bf",
	"./csvFile.svg": "4aa0",
	"./daily-calendar-svgrepo-com.svg": "ade6",
	"./danger-circle-warning.svg": "642c",
	"./data-folder-svgrepo-com.svg": "b410",
	"./data-line.svg": "d6c9",
	"./data-service.svg": "4c37",
	"./deal-svgrepo-com.svg": "95fb",
	"./delivered-box-verification.svg": "af57",
	"./delivery-date.svg": "2496",
	"./delivery-truck-error.svg": "53ff",
	"./delivery-truck-time.svg": "715b",
	"./delivery-truck.svg": "1062",
	"./delivery.svg": "4a78",
	"./disabled.svg": "6935",
	"./double-arrow-left-white.svg": "9c89",
	"./double-left-w.svg": "c037",
	"./double-right-w.svg": "35e4",
	"./down.svg": "d8aa",
	"./download.svg": "f28e",
	"./edit.svg": "daf0",
	"./email.svg": "43be",
	"./en.svg": "eff4",
	"./error.gif": "dfd9",
	"./error2.gif": "8c2b",
	"./event-log.svg": "9e10",
	"./facebook.svg": "8485",
	"./family-of-3-whole-body-svgrepo-com.svg": "dc9f",
	"./features/banner.svg": "7826",
	"./features/call.svg": "1306",
	"./features/dashboard.svg": "5040",
	"./features/data.svg": "9e0d",
	"./features/language.svg": "4612",
	"./features/menu.svg": "e82d",
	"./features/order.svg": "a60a",
	"./features/social.svg": "a4ad",
	"./fi-rr-cloud-upload.svg": "35e8",
	"./fidelity.svg": "67d8",
	"./find-location.svg": "0477",
	"./fr.svg": "7b8a",
	"./globe-no-svgrepo-com.svg": "db09",
	"./graph-svgrepo-com.svg": "0016",
	"./hands-helping.svg": "9c78",
	"./heart-full-red.svg": "d21a",
	"./heart-red.svg": "f51e",
	"./help.svg": "acc2",
	"./history-lock.svg": "d461",
	"./home-w.svg": "9659",
	"./home.svg": "ac9d",
	"./i1.png": "e48d",
	"./i2.png": "0da2",
	"./i3.png": "113b",
	"./image-w.svg": "605b",
	"./image.svg": "931c",
	"./info-circle-w.svg": "0055",
	"./info-circle.svg": "6668",
	"./info-custom.svg": "9dca",
	"./info.svg": "76ed",
	"./instagram-w.svg": "0098",
	"./instagram.svg": "bd6c",
	"./instam-arrow-left.svg": "95c0",
	"./left-2.svg": "3b76",
	"./m1.png": "4208",
	"./m2.png": "05f6",
	"./m3.png": "72e6",
	"./m4.png": "a8f4",
	"./m5.png": "210e",
	"./machinery.svg": "ca8f",
	"./map-point-rotate.svg": "bc38",
	"./map.svg": "0443",
	"./marker-near.svg": "312d",
	"./marker.png": "6ae8",
	"./menu-dots-w.svg": "eabc",
	"./menu.svg": "d17f",
	"./minus-circle.svg": "4ade",
	"./minus-p.svg": "05d1",
	"./minus-s.svg": "3f53",
	"./multiImages.svg": "a942",
	"./near.svg": "e9e5",
	"./next.svg": "0043",
	"./notes-s.svg": "0cdd",
	"./pencil.svg": "e51f",
	"./pharmaMarker.png": "c9d2",
	"./phone.svg": "c3bb",
	"./plane-svgrepo-com.svg": "5fad",
	"./premium-badge-gold.svg": "69a8",
	"./print.svg": "671e",
	"./printer.svg": "345d",
	"./promotion.svg": "7247",
	"./qr-code-interactive.svg": "d2a2",
	"./qr-icon.svg": "84fb",
	"./qrc.svg": "41f2",
	"./question-circle.svg": "1f28",
	"./recipt.svg": "5354",
	"./recycling-recycle.svg": "f5fd",
	"./refresh-circle-white.svg": "a42e",
	"./refresh-warning.svg": "97da",
	"./refresh.svg": "53fa",
	"./right-2.svg": "5999",
	"./right.svg": "37af",
	"./send-hor.svg": "7ee4",
	"./setting-line.svg": "d8c2",
	"./setting-s.svg": "62a2",
	"./settings.svg": "9174",
	"./share-icon.svg": "c4ad",
	"./share-svgrepo-com.svg": "48cd",
	"./sign-out.svg": "8e2f",
	"./smart-home-angle-svgrepo-com.svg": "c11a",
	"./star-s.svg": "f8c8",
	"./starRate.svg": "9d06",
	"./status.svg": "c10e",
	"./stopwatch.svg": "aac5",
	"./target-2-svgrepo-com.svg": "2d92",
	"./target-and-arrow-svgrepo-com.svg": "aedc",
	"./tn-map.svg": "773c",
	"./transfer.svg": "f62e",
	"./trash-p.svg": "ef29",
	"./trash.svg": "af22",
	"./tray-dish-svgrepo-com.svg": "4d25",
	"./twitter.svg": "acf9",
	"./user-alt.svg": "9039",
	"./user-g.svg": "4028",
	"./user-p.svg": "4e1e",
	"./user.svg": "6aed",
	"./users-2-svgrepo-com.svg": "b1b6",
	"./users.svg": "d956",
	"./waiter-j.svg": "a85c",
	"./waiter-w.svg": "01de",
	"./waiter.svg": "6f0b",
	"./whatsapp.svg": "7583"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";